import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { IonicModule } from '@ionic/angular';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TranslocoModule } from '@ngneat/transloco';

import { TelusCommonModule } from '../common/common.module';

import { TableComponent } from './table';
import { TableHeaderComponent } from './table-header/table-header';
import { TableItemComponent } from './table-item/table-item';
import { DropdownComponent } from './dropdown/dropdown';
import { ColumnVisivilityComponent } from './column-visibility/column-visibility';
import { TelusTableOptionsComponent } from './table-options/table-options';
import { SafeContentPipe } from '../pipes/safe/safe-pipe.module';
import { ColumnFilterComponent } from './column-visibility/column-filter';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ScrollingModule,
    FormsModule,
    TranslocoModule,
    TelusCommonModule,
    NgxDatatableModule,
    TranslocoLocaleModule.forRoot(),
    SafeContentPipe,
  ],
  declarations: [
    TableComponent,
    TableHeaderComponent,
    TableItemComponent,
    ColumnVisivilityComponent,
    ColumnFilterComponent,
    TelusTableOptionsComponent,
    DropdownComponent,
  ],
  exports: [TableComponent],
})
export class TableModule {}
